export default class NewsletterForm {
    
    static get selector() {
        return '.newsletterForm';
    }

    constructor(el) {
        this.el = el;
        this.form = this.el.querySelector('.newsletterForm__form');
        this.response = this.el.querySelector('.newsletterForm__disclaimer');
        this.setEvents();
    }

    suscribe() {
        let formData = new FormData(this.form);
            formData.set('action', 'suscribe_newsletter'); // add Wp action
        fetch(ajaxurl, {
            method: "POST",
            body: formData
        })
        .then((response) => {
            var contentType = response.headers.get("content-type");
            if(contentType && contentType.indexOf("application/json") !== -1) {
                response.json().then((json) => {
                    this.appendResponse(json);
                });
            }
            else{
                console.log("Oops, nous n'avons pas du JSON!");
            }
        })
        .catch((error) => {
            console.error(error);
        });
        this.el.classList.add('newsletterForm--loading');
    }

    appendResponse(data) {
        this.el.classList.remove('newsletterForm--loading');
        this.response.innerHTML = data.message;
        this.response.classList.add('newsletterForm__disclaimer--active');
        /*
        if(data.isValid){
            this.el.classList.add('newsletterForm--valid');
            this.el.classList.remove('newsletterForm--error');
        }
        else{
            this.el.classList.add('newsletterForm--error');
            this.el.classList.remove('newsletterForm--valid');
        }*/
    }

    clearResponse(){
        this.response.innerHTML = "";
    }

    setEvents() {
        this.form.addEventListener('submit', (e) => { this.e_submitForm(e); }, false);
        this.form.addEventListener("input", (e) => { this.e_changeForm(e); }, false);
    } 

    e_submitForm(e) {
        e.preventDefault();
        this.suscribe();
    }

    e_changeForm(){
        //this.clearResponse();
    }

}